const billInfo = {
  state: {
    detail: {},
    payType: ''
  },
  actions: {

  },
  mutations: {
    setBill(state, payload) {
      state.detail = Object.assign({}, payload)
    },
    setPayType(state, payload) {
      state.payType = payload
    }
  },
  getters: {
  }
}

export default billInfo
